import {
  Anchor,
  COLOR_PALETTE,
  Group,
  OptimizeImage,
  desktopFirstMediaQuery,
} from '@inflearn/ds-react-next';
import { NEXT_PUBLIC_CDN_URL } from '../../../appConfig';
import { INFLEARN_URL } from '../../constants/urls';

export const UnAuthorizedHeader = () => {
  return (
    <Group
      pos="sticky"
      top={0}
      bg="white"
      px={72}
      h={64}
      align="center"
      styles={{
        root: {
          borderBottom: `1px solid ${COLOR_PALETTE.gray[2]}`,
          zIndex: 1,
          [desktopFirstMediaQuery.mobile]: { justifyContent: 'center' },
          picture: { display: 'flex' },
        },
      }}
    >
      <Anchor href={INFLEARN_URL.MAIN()}>
        <OptimizeImage src={`${NEXT_PUBLIC_CDN_URL}/assets/brand/logo.png`} width={110} />
      </Anchor>
    </Group>
  );
};
